// Émission d'événements pour le mode External

import {CardFace} from '../../types/flipcardTypes';

export class ExternalEvents {
  private editor: any;

  constructor(editor: any) {
    this.editor = editor;
  }

  public emitInsertImageEvent(cardId: string, face: CardFace): void {
    this.editor.dispatch('flipcard:insert-image', {
      cardId,
      face,
      editor: this.editor
    });
  }

  public emitDeleteCardEvent(cardId: string): void {
    this.editor.dispatch('flipcard:delete-card', {
      cardId,
      face: null,
      editor: this.editor
    });
  }

  public handleImageInsertion(cardId: string, face: CardFace): void {
    this.emitInsertImageEvent(cardId, face);
  }

  public handleCardDelete(cardId: string): void {
    this.emitDeleteCardEvent(cardId);
  }
}
